// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1KsOU","row":"ProcedureTreatmentSummary_row__18mkX"};